'use client';

import { useEffect } from 'react';
import './globals.css';
import { ErrorScreen } from '@/components/ui/error-screen';
import { reportCaughtError } from '@/lib/analytics/posthog';

/**
 * The last resort, when the root layout itself fails: it replaces the whole
 * document, so it brings its own <html> and <body>. A full reload is the
 * retry, since the layout that failed is what a reset would re-run.
 */
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    reportCaughtError(error, 'global');
  }, [error]);
  return (
    <html lang="en">
      <body>
        <ErrorScreen onRetry={() => window.location.reload()} />
      </body>
    </html>
  );
}
